import { Component, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataService } from 'src/app/core/data.service';
import { Header } from 'src/app/shared/components/header/header.model';
import { FaqServiceService } from './faq-service.service';
import { FAQLoginEnum } from 'src/app/shared/general/faq-login-enum';
import { Router } from '@angular/router';
import { UploadService } from 'src/app/shared/services/upload.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { UntypedFormGroup } from '@angular/forms';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
  registerForm: UntypedFormGroup;
  pageNumber: number = 1;
  pageSize: number = 5;
  category: string;
  faqList = [];
  categoryList = [];
  totalCount: number = 0;
  hideLoadMoreOption = false;
  title = 'kpmg-advent';
  headerData: Header = new Header();
  faqCategories:any[]=[];
  faqDetails:any;
  isPostLogin:boolean=false;
  faqQuestionAnswerList:any[]=[];
  initialFAQQuestionAnswerList:any[]=[];
  isLoadMoreClicked=false;
  description:any;
  public Editor = ClassicEditor;
  public config = {
    height:'50px',
    placeholder: 'Type the content here!',
    toolbar: [
    ],
    link: {
      decorators: {
        addTargetToExternalLinks: {
          mode: 'automatic',
          callback: url => /^(https?:)?\/\//.test(url),
          attributes: {
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        }
      },
      defaultProtocol: 'http://'
    }
  }
  constructor(private spinnerService: NgxSpinnerService,private faqServiceService :FaqServiceService,
    private dataService: DataService,  private router: Router, private uploadService: UploadService) {
      this.headerData.headTwo = "FAQs";
      this.headerData.headTwoDesc = "How can we help you?"
      this.headerData.isSubHeader = true;
  }
  ngOnInit() {
    if (sessionStorage.getItem('userId')) {
      this.isPostLogin = true;
      this.headerData.isHeaderRight = true;
    }
    else{
      this.headerData.isHeaderRight = false;
    }
    // this.getCategoryList();
     this.getFAQDetails();
  }
 
  getFAQDetails() {
    this.spinnerService.show();
    this.faqServiceService.getFAQDetails().subscribe((response)=>{
      this.spinnerService.hide();
      if(response){

      //logic to get Current FAQ version id andget its details
        var faq = response.find(x=> new Date(x.effectiveDate) <= new Date())

       if(faq){
        this.spinnerService.show();
        //To send current FAQID for geFAQByID call
         this.faqServiceService.getFAQById(faq.faqId).subscribe((faqDetailResponse) =>{
           this.spinnerService.hide();
           if(faqDetailResponse){
             this.faqDetails = faqDetailResponse;
             this.faqCategories=[];
             //Post Login
             if(this.isPostLogin){
               this.pushPostloginFAQCategory(faqDetailResponse?.faqCategory);
             }
              //Pre Login
             else{
               this.pushPreloginFAQCategory(faqDetailResponse?.faqCategory);
             }
           }
         });
       }
      }
    });
  }

  pushPreloginFAQCategory(categories:any[]){
    categories.forEach((element:any)=> {
      if(element?.faqLoginId==FAQLoginEnum.PreLoginId){
        this.faqCategories.push(element);
      }
    });

    //set Question Answer list
    this.faqCategories.forEach((category)=>{
      category?.faqQuestionAndAnswer.forEach((question:any)=>{
        this.faqQuestionAnswerList.push(question);
      });
    });

    ///Set first 5 records in ui and show load more option
    this.setInitialFAQQuestions();
  }
  pushPostloginFAQCategory(categories:any[]){
    categories.forEach((element:any)=> {
      if(element?.faqLoginId==FAQLoginEnum.PostLoginId){
        this.faqCategories.push(element);
      }
    });

    //set Question Answer list
    this.faqCategories.forEach((category)=>{
      category?.faqQuestionAndAnswer.forEach((question:any)=>{
        this.faqQuestionAnswerList.push(question);
      });
    });

    ///Set first 5 records in ui and show load more option
    this.setInitialFAQQuestions();
  }

  setInitialFAQQuestions(){
    //set initial FAQ questions
    this.initialFAQQuestionAnswerList = this.faqQuestionAnswerList.slice(0,5);
    
  }

  changeFAQCategory() {
  this.spinnerService.show();

  //Reset all list 
  this.faqQuestionAnswerList=[];
  this.initialFAQQuestionAnswerList =[];
  this.isLoadMoreClicked=false;

  //To show all category's questions in screen if user selects non in category drop down
  if(this.category=="null"){
    this.faqCategories=[];
    //Post Login
    if(this.isPostLogin){
      this.pushPostloginFAQCategory(this.faqDetails?.faqCategory);
    }
     //Pre Login
    else{
      this.pushPreloginFAQCategory(this.faqDetails?.faqCategory);
    }
  }
  //load all questions and answers of all category
  else if(this.category && this.category!="null"){

    let category = this.faqCategories.find(element => element.faqCategoryId==this.category);
    category?.faqQuestionAndAnswer.forEach((question)=>{
      this.faqQuestionAnswerList.push(question);
    });
    //Set initial questions
    this.setInitialFAQQuestions();
  }
  else{}

  //hide the spinner
  this.spinnerService.hide();

  }
 
  onClickToDownloadFile(path, fileName) {
    this.uploadService.downloadFile(path, fileName);
  }

  async downloadAllFiles(supportingDocuments:any[]) {
  for (let doc of supportingDocuments || []) {
    try {
      await this.uploadService.downloadFile(doc.filePath, doc.originalFileName);
      await new Promise(resolve => setTimeout(resolve, 300)); // Optional delay
    } catch (error) {
      console.warn(`Download failed for ${doc.originalFileName}`);
    }
  }
}

  onClickLoadMore() {
    this.isLoadMoreClicked=true;
    this.initialFAQQuestionAnswerList=[];
    this.faqQuestionAnswerList.forEach((element)=>{
      this.initialFAQQuestionAnswerList.push(element);
    });

    // if (!this.category) {
    //   this.category = ''
    // }
    // this.pageNumber = this.pageNumber + 1;
    // const path = 'general/getfaqdetails?Category=' + this.category +
    //   '&PageNumber=' + this.pageNumber + '&PageSize=' + this.pageSize;
    // this.spinnerService.show();
    // this.dataService.getRequest(path).subscribe((result: any) => {
    //   this.spinnerService.hide();
    //   for (let i = 0; i < result.length; i++) {
    //     this.faqList[0].push(result[i]);
    //   }
    //   if (this.totalCount == this.faqList[0].length) {
    //     this.hideLoadMoreOption = true;
    //   }
    // });
  }
  disableDescriptionField() {
    this.registerForm.controls?.description.disable();
  }
}
